var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"container-loading"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"inner one"}),_c('div',{staticClass:"inner two"}),_c('div',{staticClass:"inner three"})])
}]

export { render, staticRenderFns }